import { render, staticRenderFns } from "./SelectSkills.vue?vue&type=template&id=265a1db6&scoped=true&"
import script from "./SelectSkills.vue?vue&type=script&lang=js&"
export * from "./SelectSkills.vue?vue&type=script&lang=js&"
import style0 from "./SelectSkills.vue?vue&type=style&index=0&id=265a1db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a1db6",
  null
  
)

export default component.exports